// ACCOUNT
export const SET_CURRENT_USER = 'SET_CURRENT_USER'
export const SET_IS_LOGGED = 'SET_IS_LOGGED'
export const LIST_CONTACTS = 'LIST_CONTACTS'
export const SET_PERFIS = 'SET_PERFIS'

// GENERAL
export const INIT_DATE_FILTER = 'INIT_DATE_FILTER'
export const END_DATE_FILTER = 'END_DATE_FILTER'
export const SET_LOADING = 'SET_LOADING'
export const SET_FEEDBACK_AUTH = 'SET_FEEDBACK_AUTH'

// USER
export const SET_UFS = 'SET_UFS'
export const GET_ATESTADOS = 'GET_ATESTADOS'
export const GET_RELATORIOS = 'GET_RELATORIOS'
export const GET_OUTROS_SERVICOS = 'GET_OUTROS_SERVICOS'
export const SET_DADOS_PACIENTE = 'SET_DADOS_PACIENTE'
export const UPDATE_DADOS_PACIENTE_ORIGINAIS = 'UPDATE_DADOS_PACIENTE_ORIGINAIS'
export const GET_RECEITAS = 'GET_RECEITAS'
export const SET_RECEITA_DOCUMENTO = 'SET_RECEITA_DOCUMENTO'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_RACA_COR = 'SET_RACA_COR'
export const SET_ETNIAS = 'SET_ETNIAS'
export const SET_ACEITE_TELERRADIOLOGIA = 'SET_ACEITE_TELERRADIOLOGIA'

// PRINT DOCS
export const GET_PATIENT_PRINTED_DOCS = 'GET_PATIENT_PRINTED_DOCS'

// AVATARS
export const SET_AVATARS = 'SET_AVATARS'

// REGISTER
export const SET_NEW_USER = 'SET_NEW_USER'

export const SET_PROXIMOS_AGENDAMENTOS = 'SET_PROXIMOS_AGENDAMENTOS'
export const SET_DOCUMENTOS_RECENTES = 'SET_DOCUMENTOS_RECENTES'

// EXAMES
export const SET_EXAMES = 'SET_EXAMES'
export const SET_EXAME_DOCUMENTO = 'SET_EXAME_DOCUMENTO'
export const SET_EXAMES_FILTROS = 'SET_EXAMES_FILTROS'
export const SET_EXAME_LAUDO = 'SET_EXAME_LAUDO'
export const SET_EXAME_DADOS = 'SET_EXAME_DADOS'
export const SET_EXAME_ANEXO = 'SET_EXAME_ANEXO'

// EXAMSCHEDULE
export const SET_AGENDAMENTOS = 'SET_AGENDAMENTOS'
export const SET_LOADING_SCHEDULE = 'SET_LOADING_SCHEDULE'
export const SET_AGENDAMENTOS_DOCUMENTO = 'SET_AGENDAMENTOS_DOCUMENTO'

// ATESTADOS
export const SET_ATESTADO_RESPOSTA = 'SET_ATESTADO_RESPOSTA'
export const SET_ATESTADO_FINALIDADES = 'SET_ATESTADO_FINALIDADES'
export const LISTAS_APOIO_ATESTADO = 'LISTAS_APOIO_ATESTADO'
export const SET_ATESTADO_DADOS = 'SET_ATESTADO_DADOS'
export const DESABILITAR_BOTAO_ENVIAR = 'DESABILITAR_BOTAO_ENVIAR'

// RELATORIOS
export const SET_RELATORIO_FINALIDADES = 'SET_RELATORIO_FINALIDADES'
export const SET_RELATORIO_SOLICITACAO = 'SET_RELATORIO_SOLICITACAO'

// CIRURGIA
export const SET_SOLICITACOES_CIRURGIA = 'SET_SOLICITACOES_CIRURGIA'
export const SET_SOLICITACAO_CIRURGIA = 'SET_SOLICITACAO_CIRURGIA'
export const SET_SITUACOES_CIRURGIA = 'SET_SITUACOES_CIRURGIA'

// SOLICITAÇÃO RECEITAS
export const SET_RECEITAS_PARA_SOLICITACAO = 'SET_RECEITAS_PARA_SOLICITACAO'
export const SET_RESULTADO_SOLICITACAO_RECEITA = 'SET_RESULTADO_SOLICITACAO_RECEITA'
